import React, {useCallback, useEffect, useState, useMemo}  from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import ShippingLegAddress from './ShippingLegAddress';
import ShippingFlowFooter from '../../components/ShippingFlowFooter'; // Import the new footer component
import { useTheme } from '../../context/ThemeContext';
import Authentication from './Authentication';
import { useFormStore } from '../../stores/formData';
import BackButton from '../../components/BackButton';

const ShippingFlowAddress = ({
  onClickContinue,
  canShowBack,
  onClickBack
}) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isExpanded, setIsExpanded] = useState(true);
  const { theme } = useTheme();
  const isDark = theme === 'dark';

  const actions = useFormStore((state) => state.actions);
  const helpers = useFormStore((state) => state.helpers);
  const customerInfo = useFormStore((state) => state.formData.customerInfo);

  useEffect(() => {
    actions.form.setCurrentPage(1, 'address');
  }, []);

  useEffect(() => {
    if (customerInfo?.authToken?.length) {
      setIsAuthenticated(true);
    }
  }, [customerInfo]);

  const handleAuthentication = useCallback((authInfo) => {
    //setCustomerInfo(authInfo);
    actions.form.updateFields({
      customerInfo: authInfo,
      authToken: authInfo.authToken
    });
    setIsAuthenticated(true);
  }, [setIsAuthenticated, actions]);

  const removeLeg = (legIndex) => {
    actions.form.removeLeg(legIndex);
  };


  const containerClassName = clsx(
    'md:p-4 -scroll-mb-10',
    {
      'bg-slate-900': isDark,
      'bg-white': !isDark
    }
  );

  return (
    <div className={containerClassName}>
      <div className="max-w-7xl mx-auto">
        <BackButton onBack={onClickBack} />

        {isExpanded && !isAuthenticated && (
          <Authentication
            onAuthenticate={handleAuthentication}
          />
        )}

        {/* Main Content */}
        {isAuthenticated && (
          <div className="space-y-2">
            {helpers.getLegs().map((leg) => (
              <div key={leg.legIndex} className="p-2">
                <ShippingLegAddress
                  legIndex={leg.legIndex}
                  onClickBack={onClickBack}
                  onRemoveLeg={() => removeLeg(leg.legIndex)}
                />
              </div>
            ))}
          </div>
        )}
      
        {/* Footer with buttons */}
        <ShippingFlowFooter
          onBack={() => onClickBack?.()}
          showSecondaryButton={false}
          disabled={false}
          showPrimaryButton={isAuthenticated}
          showBack={canShowBack?.()}
          onPrimaryAction={() => onClickContinue?.()}
          primaryButtonText="Continue"
        />
      </div>
    </div>
  );
};

ShippingFlowAddress.propTypes = {
  canShowBack: PropTypes.func,
  onClickContinue: PropTypes.func.isRequired,
  onClickBack: PropTypes.func.isRequired,
};

export default ShippingFlowAddress;